<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.34375 24.4602L11.114 15.6977C11.4463 14.9254 12.2063 14.425 13.047 14.425H21.0482H22.1575M32.1927 24.4602L29.8034 18.7258"
      :stroke="fill"
      stroke-width="1.22"
    />
    <path
      d="M8.01453 24.5917H31.5219C32.3472 24.5917 33.0163 25.2607 33.0163 26.0861V31.9732H6.52016V26.0861C6.52016 25.2607 7.18921 24.5917 8.01453 24.5917Z"
      :stroke="fill"
      stroke-width="1.22"
    />
    <path
      d="M12.946 34.4957V32.2385H6.52016V34.4957C6.52016 36.2701 7.95863 37.7086 9.73307 37.7086C11.5075 37.7086 12.946 36.2701 12.946 34.4957Z"
      :stroke="fill"
      stroke-width="1.22"
    />
    <path
      d="M33.0266 34.9736V32.2285H27.5365V34.9736C27.5365 36.4896 28.7655 37.7186 30.2816 37.7186C31.7976 37.7186 33.0266 36.4896 33.0266 34.9736Z"
      :stroke="fill"
      stroke-width="1.2"
    />
    <circle
      cx="11.6271"
      cy="28.131"
      r="1.77159"
      :fill="fill"
    />
    <circle
      cx="29.3419"
      cy="28.131"
      r="1.77159"
      :fill="fill"
    />
    <path
      d="M29.0143 18.7468L28.6086 18.6344C28.6079 18.6342 28.6071 18.634 28.6064 18.6338C27.0637 18.1936 25.3361 17.5386 23.9984 16.3786C22.6851 15.2398 21.7191 13.5913 21.7191 11.0706V4.56634L29.0143 2.62097L36.3094 4.56634V11.0706C36.3094 13.6015 35.3469 15.2495 34.0369 16.3851C32.702 17.5424 30.9751 18.1932 29.4227 18.6337C29.4221 18.6339 29.4215 18.634 29.4209 18.6342L29.0143 18.7468Z"
      fill="#D1D7DF"
      :stroke="fill"
      stroke-width="1.2"
    />
    <path
      d="M24.9141 10.4147L27.1286 12.6292L33.3291 7.31445"
      :stroke="fill"
      stroke-width="1.57828"
    />
    <path
      d="M3.99902 23.5234C3.99902 22.974 4.44443 22.5286 4.99387 22.5286H6.49003C7.07113 22.5286 7.54221 22.9996 7.54221 23.5808V23.8383C7.54221 24.5229 6.89892 25.0251 6.23483 24.8591L4.75258 24.4885C4.30971 24.3778 3.99902 23.9799 3.99902 23.5234V23.5234Z"
      :fill="fill"
    />
    <path
      d="M35.7148 23.3691C35.7148 22.8197 35.2694 22.3743 34.72 22.3743H33.2238C32.6427 22.3743 32.1717 22.8453 32.1717 23.4265V23.684C32.1717 24.3686 32.815 24.8708 33.479 24.7048L34.9613 24.3343C35.4042 24.2235 35.7148 23.8256 35.7148 23.3691V23.3691Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsVerticalsHomeCarInsurance'
})

defineProps({
  fill: {
    type: String,
    default: semanticColorLookup('surface.on-surface')
  }
})
</script>
